import styled from "styled-components";

export { StyledTextField, DatePickerField } from "./FilterFields";

export const Form = styled.form`
  width: 100%;
  box-sizing: border-box;
`;

export const FlexDiv = styled.div`
  display: flex;
  height: 100%;

  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 1.2rem;

  margin-bottom: 1.5rem;
`;
export const FlexDivCustom = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.2rem;
  margin-bottom: 1.5rem;
`;

export const Field = styled.div`
  display: flex;
  flex: 1 1 31%;
  flex-direction: column;
  gap: 0.2rem;
  align-items: flex-start;
  min-width: 240px;

  @media (max-width: 900px) {
    flex: 1 1 48%;
  }

  @media (max-width: 600px) {
    flex: 1 1 100%;
    min-width: 0;
  }
`;

export const DatePickerContainer = styled.div`
  position: relative;
  margin-bottom: 1.5rem;

  > div {
    flex-wrap: wrap;
    gap: 1.2rem;
  }
`;

export const ButtonsWrapper = styled.div.attrs({ className: "filter-panel__actions" })``;
